/**
 * THE HOSTNAME MARKERS the browser-side environment check reads -- the label suffix that makes a subdomain a DEV
 * subdomain, and the substring that makes a hostname a PRODUCTION one. Consumed by `isProductionHostname`
 * (`utils/config/env-config.ts`), which is the canonical browser-side production check every caller delegates to.
 *
 * A SECURITY-ADJACENT DECISION IN ITS OWN LEAF, deliberately. These two strings used to arrive from one
 * generically-named `suffixes` leaf whose OTHER consumer was the D1 DATABASE-NAME suffix stripper in
 * `utils/compliance/rule-helpers/resource-schema-builder-helpers.ts` -- a scanner's `Storage-Gateway-Dev` ->
 * `storage-gateway` collapse. Two unrelated decisions bound by the coincidence that both spell an environment `-dev`
 * / `-prod`: an edit made for the scanner's naming convention would have silently moved which hostnames read as
 * production. That is the class the duplicate-abstraction engine hard-skips at `siteFacts`'s
 * `const-leaf-declaration-element` fact (`tools/lib/dedup-engine/site-facts.mjs`) and the class
 * `adoptionAgreement`'s `RECORD_NAME_STOP` strip (`tools/lib/dedup-engine/decide.mjs`) refuses to call
 * agreement.
 *
 * NOT the deploy-env NAMES (`DEPLOY_ENV_TARGETS`, `const/config-deploy-targets.ts`) and not the environment enum
 * (`ENVIRONMENTS`, `const/config-environments.ts`): those key configuration, these are host-string shapes.
 */

export const HOSTNAME_ENV_MARKER = {
	/** Leftmost-label suffix that marks a `*.federa.com` subdomain as DEV (`api-dev.federa.com`). */
	DEV_SUBDOMAIN_SUFFIX: '-dev',
	/** Substring anywhere in a hostname that marks it PRODUCTION. */
	PRODUCTION_SUBSTRING: '-prod',
} as const;
